define([
  'react',
  'prop-types',
  'axios',
], (React, PropTypes, axios) => {

  // Caches the svg data for each src so we don't have to load
  // them more than once. This fixes an issue we were having with
  // the svg reloading when changing the key on the popup.  It caused the
  // svg component to be an entirely new component, making it load again.
  const svgCache = { };
  // Cache size data so we don't have to reload it.
  const svgSizeCache = { };

  class SVGImage extends React.Component {
    static propTypes = {
      src: PropTypes.string,
      onChangeSize: PropTypes.func,
    };

    static defaultProps = {
      preserveAspectRatio: false,
      relative: false,
    };

    constructor(props) {
      super(props);

      this.state = {
        svgEl: null,
      };

      this.hasLoaded = false;
      this.isComponentMounted = false;
    }

    componentWillMount() {
      this.isComponentMounted = true;
      this.loadSVGSize();
      this.loadSVGData();
    }

    componentWillUnmount() {
      this.isComponentMounted = false;
    }

    // Load the svg in an image element and get the natural width and height.
    loadSVGSize() {
      const { src, onChangeSize } = this.props;
      const cachedSize = svgSizeCache[src];

      if (cachedSize) {
        if (onChangeSize) onChangeSize(cachedSize.width, cachedSize.height);
        return
      }

      const tempImage = new Image();

      tempImage.onload = function() {
        const width = tempImage.naturalWidth;
        const height = tempImage.naturalHeight;

        svgSizeCache[src] = { width, height };
        if (onChangeSize) onChangeSize(width, height);
      }

      tempImage.src = src;
    }

    loadSVGData() {
      const { src } = this.props;
      const { hasLoaded } = this;
      if (!src || hasLoaded) return;

      // We want to make sure we don't execute another load while
      // this one is going.
      this.hasLoaded = true;

      const cachedSvg = svgCache[src];
      if (cachedSvg) {
        this.setSVGData(cachedSvg);
        return;
      }

      axios.get(src).then(res => {
        const { data } = res;
        // Save data for later so we don't have to make the same request.
        svgCache[src] = data;
        this.setSVGData(data);
      }).catch(error => {
        console.log(error);
        this.hasLoaded = false;
      });
    }

    setSVGData(data) {
      if (!data) return;
      const { svgEl } = this.state;
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(data, 'image/svg+xml');

      if (!svgDoc) return;

      const newSvgEl = svgDoc.getElementsByTagName('svg')[0];

      if (this.isComponentMounted && newSvgEl !== svgEl) {
        this.setState({ svgEl: newSvgEl });
      }
    }

    getSVGHtml() {
      const { preserveAspectRatio, relative } = this.props;
      const { svgEl } = this.state;
      if (!svgEl) return '';

      const svgElClone = svgEl.cloneNode(true);
      // preserveAspectRatio can be a boolean so we make sure to put in string.
      svgElClone.setAttribute('preserveAspectRatio', `${preserveAspectRatio}`);
      
      if (!relative) {
        svgElClone.setAttribute('style', 'height: 100%; width: 100%; position: absolute; top: 0; left: 0;');
      }

      const tempEl = document.createElement('div');
      tempEl.appendChild(svgElClone);
      return tempEl.innerHTML;
    }

    render() {
      const { style } = this.props;
      const svgHtml = this.getSVGHtml();

      return (
        <div
          style={style}
          className="sumome-react-svg-image-container"
          dangerouslySetInnerHTML={{ __html: svgHtml }}
        />
      );
    }
  }

  return SVGImage;
});
